const Colors = ['lightblue' , 'lightpink' , 'lightslategray' , 'lightseagreen' , 'lightsteelblue'];
function getColor() {
  return  Colors[Math.floor(Math.random() * Colors.length + 0.3)];
}
export default getColor;